module.exports = "<ng-progress\r\n    [positionUsing]=\"'marginLeft'\"\r\n    [direction]=\"'leftToRightIncreased'\"\r\n    [color]=\"'#ffff00'\"\r\n    [trickleSpeed]=\"500\" \r\n    [thick]=\"true\" \r\n    [ease]=\"'easeInSine'\"\r\n    [showSpinner]= \"true\"\r\n></ng-progress>\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Users/calvi/Documents/AngularProjects/calvinparksportfolio/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main